import type { ReactNode } from 'react';

type ListToolbarProps = {
  /** The search field; it takes the left group's free width. */
  search: ReactNode;
  /** Beside the search, e.g. Filters. */
  filters: ReactNode;
  /** The right group, e.g. Views and the ⋮ table options. */
  actions: ReactNode;
  /** The applied-filter chips row; omitted while nothing is applied. */
  chips?: ReactNode;
};

/**
 * Table / Filters (Service Requests 7431:38466, 8227:47578): search and Filters on the left (a 417
 * group), the actions on the right, and the chips row 16 under them.
 */
export const ListToolbar = ({ search, filters, actions, chips }: ListToolbarProps) => (
  <div data-lula-ds="" className="flex flex-col gap-space-16 font-sans" data-testid="list-toolbar">
    <div className="flex flex-wrap items-center justify-between gap-space-8">
      <div className="flex w-[417px] max-w-full items-center gap-field-gap">
        {/* `!`: the legacy `.page-card-xl__head .wo-search { width: 320px }` (_cards.scss) is
            unlayered, so it beat the plain utility and the search stopped short of the 417. */}
        <div className="min-w-0 flex-1 [&_.wo-search]:w-full!">{search}</div>
        {filters}
      </div>
      <div className="flex items-center gap-button-gap-inline">{actions}</div>
    </div>
    {chips}
  </div>
);
